import { Typography } from '@mui/material';
import parse from 'html-react-parser';
import { useState, useEffect, type FC } from 'react';

import DocumentationMS from '../../api/documentation';
import useApiQuery from '../../hooks/useApiQuery';

interface PageContentProps {
  pageTitle: string;
}

const PageContent: FC<PageContentProps> = ({ pageTitle }) => {
  const { makeApiCall: getPageContent } = useApiQuery<string>(
    (...args: unknown[]): Promise<string | { data?: string }> =>
      DocumentationMS.getPageContent(args[0] as string).then((res: string | { data?: string }) =>
        typeof res === 'string' ? res : (res.data ?? '')
      )
  );
  const [htmlContent, setHtmlContent] = useState<string>('');

  useEffect(() => {
    const getContent = async (): Promise<void> => {
      const data = await getPageContent(pageTitle);
      if (data) {
        // Extract content from body tag to avoid HTML document nesting issues
        const bodyMatch = /<body[^>]*>([\s\S]*?)<\/body>/i.exec(data);
        const bodyContent = bodyMatch?.[1] ?? data;

        // Sanitize CSS variables that cause React DOM issues
        const sanitizedContent = bodyContent.replace(/var\([^)]+\)/g, (match): string => {
          // Extract fallback color from var(--css-var, #fallback)
          const fallbackMatch = /,\s*(#[a-fA-F0-9]{6}|#[a-fA-F0-9]{3}|\w+)\s*\)/.exec(match);
          return fallbackMatch?.[1] ?? '#000';
        });
        setHtmlContent(sanitizedContent);
      }
    };

    getContent();
  }, [getPageContent, pageTitle]);

  return htmlContent ? (
    <>
      <Typography
        variant='h4'
        color='primary'
      >
        {pageTitle}
      </Typography>
      <div>{parse(htmlContent)}</div>
    </>
  ) : null;
};

export default PageContent;
